import { ulid as ulidFactory, monotonicFactory } from "ulid";

const monotonic = monotonicFactory();

export function newUlid(): string {
  return ulidFactory();
}

/**
 * Monotonic ULID — guaranteed strictly increasing within a single process,
 * even when multiple are generated in the same millisecond. Use this for
 * sort keys where collision in the same ms would be a correctness problem
 * (e.g. transactions, audit log entries).
 */
export function newMonotonicUlid(): string {
  return monotonic();
}

const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/;

export function isUlid(value: string): boolean {
  return ULID_RE.test(value);
}
